// lib/base64.ts
// Works in Next.js on the server (Node or Edge) and in the browser.
// Handles full Unicode safely.

export function encodeBase64(value: string): string {
  // Server (Node.js) — prefer Buffer if available
  if (typeof window === 'undefined' && typeof Buffer !== 'undefined') {
    return Buffer.from(value, 'utf-8').toString('base64');
  }

  // Everywhere else (browser or Edge runtime) — use TextEncoder + btoa
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  // globalThis.btoa exists in browsers and the Edge runtime
  return globalThis.btoa(binary);
}

export function decodeBase64(value: string): string {
  // Server (Node.js) — prefer Buffer if available
  if (typeof window === 'undefined' && typeof Buffer !== 'undefined') {
    return Buffer.from(value, 'base64').toString('utf-8');
  }

  // Everywhere else (browser or Edge runtime) — use atob + TextDecoder
  const binary = globalThis.atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(bytes);
}
